import { JSX } from "react";
import {
    DstAssociationCard,
    DstProductDetailViewModel,
} from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";
import {
    showProductSlidersSection,
    showSpecificationInfoSection,
} from "../utils/productDetailSectionVisibility";
import { ProductGeneralInformation } from "./ProductGeneralInformation";
import { ProductSpecifications } from "./ProductSpecifications";
import { RelatedProducts } from "./RelatedProducts";

interface Props {
    data: DstProductDetailViewModel | undefined;
    isPageLoading: boolean;
    labels: DstProductDetailLabels;
    accessories: DstAssociationCard[];
    similarProducts: DstAssociationCard[];
    isAssociationsLoading: boolean;
}

export const ProductDetailsBody = ({
    data,
    isPageLoading,
    labels,
    accessories,
    similarProducts,
    isAssociationsLoading,
}: Props): JSX.Element => {
    const showSpecificationInfo = showSpecificationInfoSection(
        data,
        isPageLoading,
    );

    const showProductSliders = showProductSlidersSection(
        isPageLoading,
        isAssociationsLoading,
        accessories.length,
        similarProducts.length,
    );

    const slidersLoading = isPageLoading || isAssociationsLoading;

    return (
        <>
            {showSpecificationInfo && (
                <div className="p-product-details__specification-info">
                    <ProductGeneralInformation
                        data={data}
                        labels={labels}
                        loading={isPageLoading}
                    />

                    <ProductSpecifications
                        data={data}
                        labels={labels}
                        loading={isPageLoading}
                    />
                </div>
            )}

            {showProductSliders && (
                <div className="p-product-details__product-sliders">
                    <RelatedProducts
                        products={accessories}
                        title={labels.accessories}
                        loading={slidersLoading}
                        labels={labels}
                    />

                    <RelatedProducts
                        products={similarProducts}
                        title={labels.similarMachines}
                        loading={slidersLoading}
                        labels={labels}
                    />
                </div>
            )}
        </>
    );
};
